import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import PaymentForm from "./paymentForm";
import setupIntent from "./setupIntent";
import { connect } from "react-redux";
import { getAllUserNotification } from "../../action/notification/notification";
import { getEmailFromStorage } from "../../utils/helpers/storageUtils";
import { PropTypes } from 'prop-types';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPEAPIKEY);

export class Addcard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            stripe: true,
            elements: true,
            useOption: '',
            cardHolderIsValid:true
        }

        // this.SplitForm = this.SplitForm.bind(this);
        // this.handleSubmit = this.handleSubmit.bind(this);
        // this.useOptions = this.useOptions.bind(this);

    }

   



    callCardProcessSucess=async (data)=>{
        this.props.paymentfunctionCalls();
        if(data === 200){
            this.setState({addCardSatus:true})
                let notificationData = [];
                let email = getEmailFromStorage();
                const objTemp = { email: email};
        
                const notification = await getAllUserNotification(objTemp);
                console.log(notification);
                if (notification !== undefined) {
                    if (notification.data.statusCode === 200) {
                        notification.data.data.map((data) => {
                            
                                notificationData.push(data);
                            
                        });
        console.log(notificationData);
                        this.props.notificationData(notificationData)
            
        }
    }
}
    }

    
    cardHolderCheckValidation = () => {
        this.props.cardHolderCheckvalidation();
    }


    render() {        
        return (
            // <h1>Add CArd</h1>
            <Elements stripe={stripePromise} options={{
                fonts: [
                  {
                    src: "url(https://db.onlinewebfonts.com/t/0376a58122a881d16a294512d3c947b1.ttf)",
                    family: "proxima-nova",
                    style: "normal",
                    weight:'400'
                  },
                ],
              }}
               
                >
            
                <div className="DemoWrapper">
                    <div className="DemoPickerWrapper">
                        <div className="Demo">
                            {/* <setupIntent></setupIntent> */}
                            <PaymentForm callCardProcessSucess={this.callCardProcessSucess} cardHolderCheckValidation={this.cardHolderCheckValidation} isCheckcardHolderValid={this.props.isValidCardHolder} cardHolderName={this.props.cardHolderName}></PaymentForm>
                        </div>
                    </div>
                </div>
            </Elements>

        );
    }
}


export const mapStateToProps = (state) => {
    return {
        notificationDatas: state.dataStore.notificationDatas
    };
  };

export const mapDispatchToProps = (dispatch) => {
    return {
        notificationData: (data) => {
            return dispatch({
              type: 'NOTIFICATIONDATA',
              value: data
            });
          },
    }

}

Addcard.propTypes = {
  paymentfunctionCalls: PropTypes.func,
  notificationData: PropTypes.func,
  cardHolderCheckvalidation: PropTypes.func,
  isValidCardHolder:  PropTypes.any,
  cardHolderName: PropTypes.any,

}



export default connect(mapStateToProps,mapDispatchToProps)(Addcard);